<template>
    <div>
        <md-card-content class="body-list">
            <div v-if="!isListLoading">
                <div v-if="dropRatelist != null && dropRatelist.length > 0">
                    <div class="header-button-container add-button">
                        <md-button
                            title="Add New Rate"
                            class="md-primary md-just-icon md-round"
                            @click="createNewRate()"
                        >
                            <md-icon>note_add</md-icon>
                        </md-button>
                    </div>
                    <md-table class="custom-paginated-table">
                        <draggable
                            v-model="dropRatelist"
                            draggable=".drag-item"
                            class="custom-draggable"
                            @end="onEnd(dropRatelist)"
                        >
                            <md-table-row slot="header">
                                <md-table-head class="drag-icon"></md-table-head>
                                <md-table-head class="override-icon"></md-table-head>
                                <md-table-head>Flag Fall</md-table-head>
                                <md-table-head>Charge Per Drop Interval</md-table-head>
                                <md-table-head>Drop Interval</md-table-head>
                                <md-table-head>Included Drops</md-table-head>
                                <md-table-head>Minimum Charge</md-table-head>
                                <md-table-head>Status</md-table-head>
                                <md-table-head>Availability</md-table-head>
                                <md-table-head class="action-class">Actions</md-table-head>
                            </md-table-row>

                            <md-table-row
                                v-for="dropRate in dropRatelist"
                                :key="dropRate.rateRulesId"
                                :class="rateGroupIdHighlight === dropRate.rateRulesId ? 'drag-item highlight-row' : 'drag-item'"
                            >
                                <md-table-cell class="drag-icon">
                                    <md-icon>
                                        drag_indicator
                                    </md-icon>
                                </md-table-cell>
                                <md-table-cell class="override-icon">
                                    <md-icon v-if="dropRate.overrideRule">
                                        priority_high
                                        <md-tooltip>Override Rule</md-tooltip>
                                    </md-icon>
                                </md-table-cell>
                                <md-table-cell>
                                    <div v-if="dropRate.dropFlagfall !== null">
                                        <span v-if="dropRate.dropFlagfall.operator !== '='">
                                            {{ dropRate.dropFlagfall.operator }}
                                        </span>
                                        {{ dropRate.dropFlagfall.value | currency(dropRate.currency) }}
                                    </div>
                                    <div v-else><br /></div>
                                    <div
                                        v-if="dropRate.condition !== null && !hideConditionRules"
                                        class="condition-container"
                                    >
                                        <md-table-cell style="display: contents;">
                                            <md-chips class="md-primary condition-block" md-static>
                                                <template v-for="(oper, conditionIndex) in dropRate.condition">
                                                    <md-chip v-if="checkForOperatorData(oper)" :key="conditionIndex">
                                                        {{ formatOperatorData(oper) }}
                                                    </md-chip>
                                                    <md-chip :key="conditionIndex + '-op'">
                                                        {{ formatConditionData(oper) }}
                                                    </md-chip>
                                                </template>
                                            </md-chips>
                                        </md-table-cell>
                                    </div>
                                </md-table-cell>
                                <md-table-cell>
                                    <div v-if="dropRate.dropRatePerInterval !== null">
                                        <span v-if="dropRate.dropRatePerInterval.operator !== '='">
                                            {{ dropRate.dropRatePerInterval.operator }}
                                        </span>
                                        {{ dropRate.dropRatePerInterval.value | currency(dropRate.currency) }}
                                    </div>
                                </md-table-cell>
                                <md-table-cell>
                                    <div v-if="dropRate.dropInterval !== null">
                                        <span v-if="dropRate.dropInterval.operator !== '='">
                                            {{ dropRate.dropInterval.operator }}
                                        </span>
                                        {{ dropRate.dropInterval.value }}
                                    </div>
                                </md-table-cell>
                                <md-table-cell>
                                    <div v-if="dropRate.includedDrops !== null">
                                        <span v-if="dropRate.includedDrops.operator !== '='">
                                            {{ dropRate.includedDrops.operator }}
                                        </span>
                                        {{ dropRate.includedDrops.value }}
                                    </div>
                                </md-table-cell>
                                <md-table-cell>
                                    <div v-if="dropRate.dropMinimumCharge !== null">
                                        <span v-if="dropRate.dropMinimumCharge.operator !== '='">
                                            {{ dropRate.dropMinimumCharge.operator }}
                                        </span>
                                        {{ dropRate.dropMinimumCharge.value | currency(dropRate.currency) }}
                                    </div>
                                </md-table-cell>
                                <md-table-cell>
                                    {{ formatStatus(dropRate.dropStatuses) }}
                                </md-table-cell>
                                <md-table-cell>
                                    <selected-day :rule="dropRate" />
                                </md-table-cell>
                                <md-table-cell class="action-buttons">
                                    <md-button
                                        title="Update rate details"
                                        class="md-warning md-just-icon md-round"
                                        @click.stop="updateRate(dropRate.rateRulesId)"
                                    >
                                        <md-icon>edit</md-icon>
                                    </md-button>
                                    <md-button
                                        title="Delete rule"
                                        class="md-danger md-just-icon md-round"
                                        @click.stop="validateDeleteRate(dropRate.rateRulesId)"
                                    >
                                        <md-icon>delete</md-icon>
                                    </md-button>
                                    <md-button
                                        title="Add Condition"
                                        class="md-success md-just-icon md-round"
                                        @click.stop="openCreateCondition(dropRate.rateRulesId)"
                                    >
                                        <md-icon>rule</md-icon>
                                    </md-button>
                                </md-table-cell>
                            </md-table-row>
                        </draggable>
                    </md-table>

                    <md-card-actions class="page-footer" md-alignment="space-between" v-if="dropRatelist.length > 0">
                        <div>
                            <p v-if="total === pagination.perPage" class="card-category">
                                Page {{ pagination.currentPage }} of many
                            </p>
                            <p v-else class="card-category">Page {{ pagination.currentPage }} of {{ maxPage }}</p>
                        </div>
                        <pagination
                            v-model="pagination.currentPage"
                            class="pagination-no-border pagination-success"
                            :per-page="pagination.perPage"
                            :total="total"
                            @change-page="handleChangePage($event, pagination.perPage)"
                        />
                    </md-card-actions>
                </div>
                <div v-if="dropRatelist.length == 0 && !isListLoading" class="text-center">
                    <p class="no-result-message">No Rates Created</p>
                    <div>
                        <button class="custom-btn" @click="createNewRate">
                            Add New Rule
                        </button>
                    </div>
                </div>
            </div>
            <div v-else class="body-list">
                <div class="content-loader">
                    <fade-loader :loading="isListLoading" color="#333333" />
                    <span>LOADING</span>
                </div>
            </div>
        </md-card-content>
    </div>
</template>

<script>
/* eslint-disable import/extensions */
import { mapGetters } from 'vuex';
import FadeLoader from 'vue-spinner/src/FadeLoader';
import { GeneralMixin } from '@/mixins/GeneralMixin';
import { handleRequests, showErrorMessage, formatCondition, formatOperator, checkForOperator } from '@/helpers';
import { PAGINATION_DEFAULTS } from '@/utils/defaults';
import { Pagination, SelectedDay } from '@/components';
import { RATE_CHARGING_TYPES, RATES_DAYS_OF_THE_WEEK } from '@/utils/constants';
import CreateDropRuleContent from '@/pages/Rates/ModalComponents/CreateDropRuleContent';
import CreateConditionRuleContent from '@/pages/Rates/ModalComponents/CreateConditionRuleContent';
/* eslint-enable import/extensions */

export default {
    name: 'RatesDropDetails',
    components: {
        Pagination,
        FadeLoader,
        SelectedDay
    },
    props: {
        customerId: {
            type: Number,
            default: null
        },
        rateId: {
            type: Number,
            default: null
        },
        hideConditionRules: {
            type: Boolean,
            default: false
        },
        rateZones: {
            type: Array,
            default: () => []
        },
        driverUserId: {
            type: Number,
            default: null
        },
        driverRuleCreation: {
            type: Boolean,
            default: false
        },
        teamRegionId: {
            type: Number,
            default: null
        },
        teamTags: {
            type: Array,
            default: () => []
        }
    },
    mixins: [GeneralMixin],
    data() {
        return {
            pagination: PAGINATION_DEFAULTS,
            dropRatelist: [],
            maxPage: 1,
            loading: true,
            isListLoading: true,
            rateChargingTypes: RATE_CHARGING_TYPES,
            currency: null,
            daysOfWeek: [...RATES_DAYS_OF_THE_WEEK],
            rateGroupIdHighlight: Number(this.$route.query.rateGroupId)
        };
    },
    watch: {
        rateId(newValue, oldValue) {
            this.updateRateList();
        },
        customerId(newValue, oldValue) {
            this.updateRateList();
        },
        driverUserId(newValue, oldValue) {
            this.updateRateList();
        },
        '$route.query.rateGroupId': function (newValue, oldValue) {
            if (this.$route.query.rateGroupId) {
                this.rateGroupIdHighlight = Number(this.$route.query.rateGroupId);
                const page = this.$route.query.currentPage ?? this.pagination.currentPage;
                this.refreshRateList(page, this.pagination.perPage);
            }
        },
        teamRegionId() { 
            this.updateRateList();
        }
    },
    async mounted() {
        let currentPage = 1;
        const { type } = this.$route.params;

        if (type === 'drop') {
            currentPage = Number(this.$route.query.currentPage) || 1;
        }

        if (currentPage) {
            this.pagination.currentPage = currentPage;
        }

        await this.updateRateList(currentPage);
    },
    methods: {
        async updateRateList(currentPage = 1) {
            const {
                data: { rateList, totalItems, currency }
            } = await this.getRateList(
                this.customerId,
                this.rateId,
                this.driverUserId,
                this.driverRuleCreation,
                this.teamRegionId,
                currentPage
            );

            this.setRatesAndTotal(rateList, totalItems, currency);
        },
        formatPercentage(data) {
            if (data == null) 
                return '';
            return `${data}%`;
        },
        async getRateList(
            customerId = null,
            rateId = null,
            driverUserId = null,
            driverRuleCreation = null,
            teamRegionId = null,
            pageNumber = 1,
            totalItems = 20,
            type = 'Drop'
        ) {
            const chargeType = this.rateChargingTypes.find((x) => x.key === 'Drop');
            const rateType = chargeType.type;

            let response = {
                data: {
                    rateList: [],
                    totalItems: null
                }
            };

            try {
                this.isListLoading = true;
                const endpoint = '/api/rates/rate';

                response = await handleRequests(endpoint, {
                    params: {
                        rateType,
                        pageNumber,
                        totalItems,
                        customerId,
                        rateId,
                        driverUserId,
                        teamRegionId,
                        driverRuleCreation
                    }
                });
            } catch (error) {
                const message = `Error when getting Drop Rates`;
                showErrorMessage(this, message, null);
            }
            this.pagination.perPage = totalItems;
            this.isListLoading = false;
            return response;
        },
        async recordAddedHandlePageRefresh() {
            await this.handleChangePage(this.pagination.currentPage, this.pagination.perPage);
        },
        async handleChangePage(currentPage = 1, perPage = 20, query = null) {
            let queryData = { currentPage };

            if (query !== null) {
                queryData = query;
            }

            this.$router.replace({ path: this.$route.path, query: queryData });
            const {
                data: { rateList, totalItems, currency }
            } = await this.getRateList(
                this.customerId,
                this.rateId,
                this.driverUserId,
                this.driverRuleCreation,
                this.teamRegionId,
                currentPage,
                perPage
            );

            this.setRatesAndTotal(rateList, totalItems, currency);
            this.pagination.currentPage = currentPage;
            this.pagination.perPage = perPage;
        },
        setRatesAndTotal(data, total, currency) {
            this.dropRatelist = data;
            this.pagination.total = total || data.length;
            this.currency = currency;
            this.maxPage = Math.ceil(this.pagination.total / this.pagination.perPage);
        },
        async onEnd(list) {
            const obj = {
                rateList: list,
                pageNumber: this.pagination.currentPage,
                perPage: this.pagination.perPage
            };

            const endpoint = '/api/rates/update';
            const payload = {
                method: 'post',
                data: obj
            };

            try {
                const response = await handleRequests(endpoint, payload);

                if (response.status === 200) {
                    this.$notify({
                        message: 'Successfully updated Priority.',
                        type: 'success'
                    });
                } else if (response.status === 204) {
                    //
                } else {
                    showErrorMessage(this, 'Failed updating priority.', null);
                }
            } catch (error) {
                showErrorMessage(this, error.data, null);
            }
        },
        validateDeleteRate(rateRuleId) {
            this.$messageBox
                .show({
                    class: 'sm-modal-container',
                    title: 'Delete Rate',
                    body: 'Are you sure you want to delete this Rule?',
                    buttons: ['Confirm', 'Cancel']
                })
                .then(async (response) => {
                    if (response.toLowerCase() === 'confirm') {
                        this.isListLoading = true;
                        await this.handleDeleteRate(rateRuleId);
                    }
                });
        },
        async handleDeleteRate(rateRulesId) {
            const payload = {
                method: 'delete'
            };
            const api = `/api/rates/rateRule/${rateRulesId}`;
            try {
                await handleRequests(api, payload);
                this.$notify({
                    message: 'Rate was deleted!',
                    type: 'success'
                });

                // If the item deleted was the last one, then move to the previous page.
                if ((this.pagination.currentPage - 1) * this.pagination.perPage === this.pagination.total - 1) {
                    this.pagination.currentPage -= 1;
                    if (this.pagination.currentPage < 1) 
                        this.pagination.currentPage = 1;
                }

                this.handleChangePage(this.pagination.currentPage, this.pagination.perPage);
            } catch (e) {
                const message = 'Error when deleting a rate.';
                showErrorMessage(this, message, e);
                this.isListLoading = false;
            }
        },
        async updateRate(rateRulesId) {
            const rateDetail = await this.getRateRulesDetails(rateRulesId);
            this.$modal
                .show(CreateDropRuleContent, {
                    rateDetail,
                    isUpdate: true,
                    driverRuleCreation: this.driverRuleCreation
                })
                .then(({ record }) => {
                    if (record === 200) {
                        this.handleChangePage(this.pagination.currentPage, this.pagination.perPage);
                        this.$modal.hide();
                    }
                });
        },
        async getRateRulesDetails(rateRulesId) {
            try {
                const payload = {
                    method: 'get'
                };
                const enpoint = `/api/rates/${rateRulesId}`;
                const { data } = await handleRequests(enpoint, payload);

                return data;
            } catch (error) {
                const message = 'Error when getting the rate details';
                showErrorMessage(this, message, error);
                return null;
            }
        },
        async openCreateCondition(rateRulesId) {
            const rateDetail = await this.getRateRulesDetails(rateRulesId);

            this.$modal
                .show(CreateConditionRuleContent, {
                    isUpdate: false,
                    rateRuleId: rateRulesId,
                    rateDetail,
                    rateZones: this.rateZones,
                    teamTags: this.teamTags
                })
                .then(({ record }) => {
                    this.handleChangePage(this.pagination.currentPage, this.pagination.perPage);
                    this.$modal.hide();
                });
        },
        formatConditionData(data) {
            return formatCondition(data, this.rateZones, this.teamTags);
        },
        formatOperatorData(data) {
            return formatOperator(data);
        },
        checkForOperatorData(data) {
            return checkForOperator(data);
        },
        formatStatus(status) {
            if (status !== null && status.length >= 0) {
                return status.join(', ');
            }

            return null;
        },
        createNewRate() {
            this.$modal
                .show(CreateDropRuleContent, {
                    rateDetail: { ...this.rateDetail },
                    listLength: this.dropRatelist.length,
                    customerId: this.customerId,
                    rateGroupId: this.rateId,
                    driverRuleCreation: this.driverRuleCreation,
                    driverUserId: this.driverUserId,
                    teamRegionId: this.teamRegionId
                })
                .then(({ record }) => {
                    this.recordAddedHandlePageRefresh();
                    this.$modal.hide();
                });
        },
        selectedDay(label, length, dayIndex) {
            const index = dayIndex + 1;
            let text = label;
            if (Number(length) !== Number(index)) {
                text = ` ${text}-`;
            }
            return text;
        },
        formatIncludeSurcharge(value) {
            // eslint-disable-next-line no-extra-boolean-cast
            if (Boolean(value)) 
                return 'Yes';

            return 'No';
        },
        async refreshRateList() {
            const currentPage = Number(this.$route.query.currentPage ?? this.pagination.currentPage);
            const rateGroupId = Number(this.$route.query.rateGroupId);
            const query = { currentPage, rateGroupId };
            this.handleChangePage(currentPage, this.pagination.perPage, query);
        }
    },
    computed: {
        currentPageMax() {
            const highBound = this.currentPageMin + this.pagination.perPage;
            return this.total < highBound ? this.total : highBound;
        },
        currentPageMin() {
            return this.pagination.perPage * (this.pagination.currentPage - 1);
        },
        total() {
            return this.pagination.total;
        },
        totalPages() {
            if (this.total > 0) {
                return Math.ceil(this.total / this.pagination.perPage);
            }
            return 1;
        },
        ...mapGetters({
            user: 'user/user'
        })
    }
};
</script>

<style lang="scss" scoped>
@import './rates-dashboard-content.shared.scss';

::v-deep .md-table {
    .drag-icon {
        width: 5%;
    }
}

.drag-item {
    cursor: grab;
}

.custom-draggable {
    display: table;
    width: 100%;
    table-layout: fixed;
}

.action-class {
    width: 150px;
}

.add-button {
    float: right !important;
}

.condition-block {
    display: flex;
    flex-wrap: wrap;
    max-width: 100%;
}

.condition-container {
    width: 60vw !important;
}
</style>
